import { ApolloClient, InMemoryCache } from '@apollo/client';

const graphQlClient = new ApolloClient({
	uri: `${process.env.REACT_APP_BASE_URL}/graphql`,
	cache: new InMemoryCache(),
});

export { graphQlClient };
